export default "__VITE_ASSET__CU23xq3S__"